import { Component, OnInit } from '@angular/core';
import { EventRequest } from 'src/app/model/eventRequest';
import { NotificationService } from 'src/app/service/notification.service';
import { EventsService } from 'src/app/service/events.service';
import { NavbarService } from '../../service/navbar.service';
import { EventRequestStatus } from '../../enum/event.request.status';
import { SegmentedOption } from 'src/app/component/segmented-control/segmented-control.component';

@Component({
  selector: 'app-admin-event-requests',
  templateUrl: './event-requests.component.html',
  styleUrls: ['./event-requests.component.scss']
})
export class AdminEventRequestsComponent implements OnInit {
  requests: Array<EventRequest> = [];

  // Filtro de status como segmented (connected button group) — substitui o
  // dropdown legado. `currentStatus` = segmento ativo.
  readonly statusOptions: SegmentedOption[] = [
    { value: EventRequestStatus.PENDING, label: 'status.PENDING' },
    { value: EventRequestStatus.ACCEPTED, label: 'status.ACCEPTED' },
    { value: EventRequestStatus.REJECTED, label: 'status.REJECTED' },
  ];
  currentStatus: EventRequestStatus = EventRequestStatus.PENDING;

  /** Texto do filtro (busca em chip no header). Filtra os cards já carregados
   *  para o status atual. */
  search = '';

  /** True enquanto as requisições do status atual estão sendo buscadas —
   *  exibe os cards-placeholder (como na página Eventos). Começa true pra
   *  mostrar os skeletons já no primeiro carregamento. */
  loading = true;

  constructor(
    private notificationService: NotificationService,
    private navbarService: NavbarService,
    private eventsService: EventsService,
  ) { }

  ngOnInit() {
    // Abre na mesma seleção do segmento ativo (Pendente).
    this.filterByStatus(this.currentStatus);
  }

  get baseUrl(): string {
    return window.location.origin;
  }

  /** Requests do status atual filtradas pelo texto de busca (sigla, nome, ano,
   *  URL) — acento-insensível. */
  get filteredRequests(): Array<EventRequest> {
    const query = (this.search || '').trim();
    if (!query) { return this.requests; }
    const normalize = (s: string) =>
      (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    const term = normalize(query);
    return this.requests.filter(r =>
      normalize(`${r.acronym || ''} ${r.year || ''} ${r.name || ''} ${r.uri || ''}`).includes(term)
    );
  }

  requestLink(request: EventRequest) {
    return `/admin/event/request/${request.id}`;
  }

  filterByStatus(status: EventRequestStatus): void {
    this.currentStatus = status;
    this.loading = true;
    this.navbarService.loadingStart();
    this.eventsService.getAllEventRequests(status).subscribe(
      requests => {
        this.requests = requests;
        this.loading = false;
        this.navbarService.loadingStop();
      },
      () => {
        this.loading = false;
        this.navbarService.loadingStop();
      }
    );
  }
}
